import React from "react";

const BulbBook = ({ className, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 100 100"
      className={className}
    >
      <title>About Menu</title>
      <path d="M99,98H56.06c1.84-10.18,31.42-15.71,43-17a1,1,0,0,0-.22-2c-1.79.2-43,5-44.84,19H45.9C44,84,2.9,79.21,1.11,79a1,1,0,0,0-.22,2c11.61,1.3,41.16,6.82,43,17H1a1,1,0,0,0,0,2H99a1,1,0,0,0,0-2Z" />
      <path d="M34.85,96H35a1,1,0,0,0,.15-2l-34-5.15a1,1,0,1,0-.3,2Z" />
      <path d="M98.85,89l-34,5A1,1,0,0,0,65,96h.15l34-5a1,1,0,1,0-.29-2Z" />
      <path d="M50,7a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V6A1,1,0,0,0,50,7Z" />
      <path d="M79,36a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2H80A1,1,0,0,0,79,36Z" />
      <path d="M15,37h5a1,1,0,0,0,0-2H15a1,1,0,0,0,0,2Z" />
      <path d="M76,22a1,1,0,0,0,.5-.13l4.33-2.5a1,1,0,0,0-1-1.73l-4.33,2.5A1,1,0,0,0,76,22Z" />
      <path d="M64.5,10.89a1,1,0,0,0,1.37-.37l2.5-4.33a1,1,0,0,0-1.73-1l-2.5,4.33A1,1,0,0,0,64.5,10.89Z" />
      <path d="M34.13,10.52a1,1,0,1,0,1.73-1l-2.5-4.33a1,1,0,0,0-1.73,1Z" />
      <path d="M19.19,19.37l4.33,2.5a1,1,0,0,0,1-1.73l-4.33-2.5a1,1,0,0,0-1,1.73Z" />
      <path d="M41.5,61V76a1,1,0,0,0,0,.16c0,.06,1,5.84,8.49,5.84s8.48-5.78,8.49-5.84a1,1,0,0,0,0-.16V61c0-4.53,2.29-7.33,4.94-10.57C67,46.1,71,41.19,71,31a21,21,0,1,0-42,0c0,10.18,4,15.09,7.56,19.42C39.21,53.67,41.5,56.47,41.5,61Zm2,1h13v3h-13Zm0,5h13v3h-13Zm0,5h13v3h-13ZM50,80c-3.8,0-5.41-1.77-6.07-3H56.07C55.4,78.23,53.79,80,50,80Zm0-68A19,19,0,0,1,69,31c0,9.47-3.77,14.08-7.11,18.16C59.3,52.33,56.84,55.34,56.53,60H56V41.24l4.89-9.79a1,1,0,1,0-1.79-.89l-5,10A1,1,0,0,0,54,41V60H46V41a1,1,0,0,0-.11-.45l-5-10a1,1,0,0,0-1.79.89L44,41.24V60h-.53c-.31-4.66-2.77-7.67-5.36-10.84C34.77,45.09,31,40.47,31,31A19,19,0,0,1,50,12Z" />
    </svg>
  );
};

export default BulbBook;



// WEBPACK FOOTER //
// ./resources/assets/js/app/Icons/BulbBook.icon.js